import React from "react";
import { connect } from "react-redux";
import ReactEcharts from "echarts-for-react";
import {debtsChartOption} from "../../Data/Charts";
import "echarts-gl";
class DebtsDataChart extends React.Component {
  componentDidMount() {

  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.debtsDataChart !== this.props.debtsDataChart) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const { debtsDataChart } = this.props;
    if (debtsDataChart.length === 0) return [];

    const months = debtsDataChart.map(item => `${item.month} ${item.year}`);
    const receivableAmounts = debtsDataChart.map(item => item.total_amount || 0);
    const collectedAmounts = debtsDataChart.map(item => item.total_collected_amount || 0);
    return {
      months,
      receivableAmounts,
      collectedAmounts
    };
  };
  render() {

    const chartData = this.chartPlace();

    const option = debtsChartOption(chartData);

    return (
       <ReactEcharts option={option}>
         opts={{ renderer: 'svg' }}
         style={{ height: '400px', width: '100%' }}
       </ReactEcharts>

    );
  }
}

const mapStateToProps = (state) => ({
  debtsDataChart: state.analyticalReducer.debtsDataChart
});

export default connect(mapStateToProps, {})(DebtsDataChart);
